import { useState } from "react";

export const useToggleSet = <T extends string | number>() => {
    const [set, setSet] = useState(new Set<T>());

    function toggle(item: T): void {
        setSet((prevSet) => {
            const newSet = new Set(prevSet);
            newSet.has(item) ? newSet.delete(item) : newSet.add(item);

            return newSet;
        });
    }

    function has(item: T): boolean {
        return set.has(item)
    }

    return { items: Array.from(set), toggle, has };
};
